var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_0_748_21211_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 1.375C26.1127 1.375 33.5 8.7623 33.5 17.875C33.5 26.9877 26.1127 34.375 17 34.375C7.8873 34.375 0.5 26.9877 0.5 17.875C0.5 8.7623 7.8873 1.375 17 1.375Z",
    fill: "url(#paint0_linear_748_21211)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.375C26.1127 1.375 33.5 8.7623 33.5 17.875C33.5 26.9877 26.1127 34.375 17 34.375C7.8873 34.375 0.5 26.9877 0.5 17.875C0.5 8.7623 7.8873 1.375 17 1.375Z",
    stroke: "url(#paint1_linear_748_21211)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.6531L24.7781 7.875L27 10.0969L19.2219 17.875L27 25.6531L24.7781 27.875L17 20.0969L9.22187 27.875L7 25.6531L14.7781 17.875L7 10.0969L9.22187 7.875L17 15.6531Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_748_21211_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 1.375C26.1127 1.375 33.5 8.7623 33.5 17.875C33.5 26.9877 26.1127 34.375 17 34.375C7.8873 34.375 0.5 26.9877 0.5 17.875C0.5 8.7623 7.8873 1.375 17 1.375Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_748_21211",
    x1: 17,
    y1: 0.875,
    x2: 17,
    y2: 34.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_748_21211",
    x1: 17,
    y1: 0.875,
    x2: 17,
    y2: 34.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.837a73946c1f6f4f509c6840514772b7.svg";
export { ForwardRef as ReactComponent };